<template lang="html">
  <div>
    <div class="alert alert-danger" v-show="!conexao">
        <strong>
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          O Servidor do PagSeguro não está disponível no momento!
        </strong> <br>
         Não foi possivel estabelecer conexão com PagSeguro,
         <b>atualize a página</b> para tentar novamente,
         se o erro persistir volte mais tarde!
    </div>
  </div>
</template>

<script>

export default {

  name: 'alert-conect-pag-seguro',

  data(){
    return{
        conexao : true
    }
  },

  created(){
      this.verifiqueConexao()
  },

  methods:{

    verifiqueConexao(){
        axios.get('/api/testar-conexao-pagseguro').then(({ data }) => {
            this.conexao = data.conexao
            if (data.conexao) {
              console.log('sessão PagSeguro -> '+ data.id_session)
              PagSeguroDirectPayment.setSessionId(data.id_session)
            }
        })
    }

  }

}

</script>
<style lang="css">
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/especificos/AlertConectPagSeguro.vue